import React from 'react'

import * as c from '../../../common'
import {
  MediaData,
  MediaKind,
  getMediaItemSrc,
  makeSelectMedia,
  pickBy,
  useSelector,
} from '../../../common'

export function useGetMediaUrls(
  content: 'all' | 'images' | 'videos' | 'mediaItem' | 'images-videos',
  customerID: string,
  ofWhat: MediaKind,
) {
  const selectCustomerMedia = React.useMemo(() => makeSelectMedia(), [])

  const selectorArgs = React.useMemo(
    () => ({
      customerID,
      mediaKind: ofWhat,
    }),
    [customerID, ofWhat],
  )

  const customerMedia = useSelector((_) => selectCustomerMedia(_, selectorArgs))

  const filteredMedia = React.useMemo(
    () =>
      pickBy(
        customerMedia,
        (mediaItem) =>
          mediaItem.image_of.toLowerCase().includes(ofWhat) ||
          mediaItem.video_of.toLowerCase().includes(ofWhat),
      ),
    [customerMedia, ofWhat],
  )

  if (content === 'all') {
    const urls = Object.values(filteredMedia).map((value) => {
      return getMediaItemSrc(value)
    })

    return urls
  }
  if (content === 'images') {
    const images = Object.values(filteredMedia).filter(
      (value) => value.image_of,
    )

    const urls = images.map((value) => {
      return getMediaItemSrc(value)
    })

    return urls
  }
  if (content === 'mediaItem') {
    const images = Object.keys(filteredMedia)

    return images
  }
  if (content === 'videos') {
    const videos = Object.values(filteredMedia).filter(
      (value) => value.video_of,
    )

    const urls = videos.map((value) => {
      return getMediaItemSrc(value)
    })

    return urls
  }
  if (content === 'images-videos') {
    const media = Object.values(filteredMedia)

    const urls = media.map((value) => {
      return {
        type: value.image_of ? 'img' : 'video',
        url: getMediaItemSrc(value),
      }
    }) as MediaData[]

    return urls
  }

  return c.emptyArrStr
}
